import React from "react";
import { PageHeader, DemoBadge } from "../components/common/PageParts";
import { CalendarDays } from "lucide-react";

const EVENTS = [
  { time: "20:30 WITA", country: "US", event: "CPI (YoY)", impact: "high", forecast: "3.1%", previous: "3.2%" },
  { time: "01:00 WITA", country: "US", event: "FOMC Rate Decision", impact: "high", forecast: "5.25%", previous: "5.25%" },
  { time: "19:00 WITA", country: "EU", event: "ECB Press Conference", impact: "medium", forecast: "—", previous: "—" },
  { time: "15:00 WITA", country: "UK", event: "GDP (QoQ)", impact: "medium", forecast: "0.2%", previous: "0.1%" },
  { time: "07:30 WITA", country: "JP", event: "BoJ Policy Rate", impact: "high", forecast: "-0.1%", previous: "-0.1%" },
];
const IMP = { high: "var(--red)", medium: "var(--amber)", low: "var(--text-dim)" };

export default function EconomicCalendar() {
  return (
    <div className="ym-fade">
      <PageHeader title="Economic Calendar" subtitle="High-impact macro events affecting crypto risk sentiment"
        right={<DemoBadge />} />
      <div className="ym-card p-3 mb-4 text-[12px]" style={{ color: "var(--text-muted)", borderColor: "rgba(245,158,11,.3)", background: "rgba(245,158,11,.05)" }}>
        Sample schedule shown as <b style={{ color: "var(--amber)" }}>DEMO</b>. Connect a TradingEconomics or FRED key in Settings to stream the live calendar.
      </div>
      <div className="ym-panel p-2">
        <table className="w-full text-[12px]">
          <thead><tr className="text-[10px] tracking-wide" style={{ color: "var(--text-dim)" }}>
            <th className="text-left py-2 px-3 font-semibold">TIME (WITA)</th>
            <th className="text-left py-2 font-semibold">REGION</th>
            <th className="text-left py-2 font-semibold">EVENT</th>
            <th className="text-center py-2 font-semibold">IMPACT</th>
            <th className="text-right py-2 font-semibold">FORECAST</th>
            <th className="text-right py-2 px-3 font-semibold">PREVIOUS</th>
          </tr></thead>
          <tbody>
            {EVENTS.map((e, i) => (
              <tr key={i} style={{ borderTop: "1px solid var(--border-soft)" }}>
                <td className="py-3 px-3 tabnum font-semibold">{e.time}</td>
                <td className="py-3"><span className="pill" style={{ background: "var(--panel-2)", borderColor: "var(--border)", color: "var(--text-muted)" }}><CalendarDays size={11} /> {e.country}</span></td>
                <td className="py-3">{e.event}</td>
                <td className="py-3 text-center"><span className="capitalize text-[11px] font-semibold" style={{ color: IMP[e.impact] }}>{e.impact}</span></td>
                <td className="py-3 text-right tabnum">{e.forecast}</td>
                <td className="py-3 px-3 text-right tabnum" style={{ color: "var(--text-muted)" }}>{e.previous}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
